<template>
  <layouts-header></layouts-header>
  <layouts-sidebar></layouts-sidebar>
  <div class="page-wrapper">
    <div class="content">
      <div class="row">
        <div class="col-md-12">
          <!-- Page Header -->
          <page-header :title="title" />

          <div class="row mb-2">
            <div class="col-md-12">
              <div
                class="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end"
              >
                <div class="dropdown me-2 bg-success">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-toggle"
                    data-bs-toggle="dropdown"
                  >
                    <i class="ti ti-package-export me-2"></i>Import/Export
                  </a>
                  <div class="dropdown-menu dropdown-menu-end">
                    <ul>
                      <li>
                        <a
                          href="javascript:void(0);"
                          class="dropdown-item"
                          @click="downloadEmailExcel"
                        >
                          <i class="ti ti-download text-blue me-1"></i> Export
                          Email
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <!-- Search & Filters -->
            <div class="card-header">
              <div class="row align-items-center">
                <div class="col-sm-3 mb-2">
                  <div class="icon-form mb-3 mb-sm-0">
                    <span class="form-icon"><i class="ti ti-search"></i></span>
                    <input
                      type="text"
                      v-model="searchQuery"
                      class="form-control"
                      placeholder="Companies..."
                      @input="onSearch"
                    />
                  </div>
                </div>
                <div class="col-sm-3 mb-2">
                  <select
                    v-model="selectedIndustryType"
                    class="form-control"
                    @change="onSearch"
                  >
                    <option value="">Select Industries</option>
                    <option
                      v-for="(industry, index) in industryTypesArr"
                      :key="index"
                      :value="industry.name"
                    >
                      {{ industry.name }}
                    </option>
                  </select>
                </div>
                <div class="col-md-3 mb-2">
                  <multiselect
                    v-model="exhibitions"
                    :options="exhibitionsArr"
                    track-by="id"
                    label="name"
                    multiple
                    placeholder="Exhibitions"
                    @input="onSearch"
                  />
                </div>
                <div class="col-md-3 mb-2">
                  <div
                    class="daterange-picker d-flex align-items-center justify-content-center"
                  >
                    <div class="form-sort me-2">
                      <i class="ti ti-calendar"></i>
                      <input
                        type="text"
                        class="form-control date-range bookingrange"
                        ref="dateRangeInput"
                      />
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mb-2">
                  <multiselect
                    v-model="employees"
                    :options="employeesArr"
                    track-by="id"
                    label="name"
                    multiple
                    placeholder="Select Employees"
                    @input="onSearch"
                  />
                </div>
              </div>
            </div>

            <!-- Table -->
            <div class="card-body">
              <div v-if="!isLoading" class="table-responsive custom-table">
                <a-table
                  class="table"
                  :columns="columns"
                  :data-source="data"
                  :row-selection="rowSelection"
                  row-key="id"
                  table-layout="fixed"
                  :pagination="pagination"
                  :loading="isLoading"
                  @change="handleTableChange"
                >
                  <template #bodyCell="{ column, record }">
                    <template v-if="column.key === 'initial_info'">
                      <ul class="custom-text-truncation">
                        <li>
                          {{ record.organization_name }}<br />{{
                            record.address
                          }}
                        </li>
                      </ul>
                    </template>

                    <template v-else-if="column.key === 'prospect_exhibitions'">
                      <ul class="custom-text-truncation">
                        <li v-for="(ex, i) in record.exhibitions" :key="i">
                          {{ ex.name }}
                        </li>
                      </ul>
                    </template>

                    <template v-else-if="column.key === 'industry_type'">
                      <div>{{ record.industry?.type }}</div>
                    </template>

                    <template v-else-if="column.key === 'created_by'">
                      <div class="custom-text">{{ record.user?.name }}</div>
                    </template>

                    <template v-else-if="column.key === 'created_at'">
                      {{ formatDate(record.created_at) }}
                    </template>
                  </template>
                </a-table>
              </div>

              <div v-else>
                <p>Loading...</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <prospect-delete-modal v-if="isShowModal" @refresh="refresh" />
  <prospect-import-modal v-if="isShowModal" @refresh="refresh" />
</template>

<script>
import http from "@/utils/http";
import Multiselect from "vue-multiselect";
import moment from "moment";
import { mapGetters } from "vuex";
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";
import DateRangePicker from "daterangepicker";

export default {
  components: { Multiselect },
  data() {
    return {
      title: "From Prospects",
      data: [],
      searchQuery: "",
      selectedIndustryType: "",
      exhibitions: [],
      employees: [],
      startDate: moment().format("YYYY-MM-DD"),
      endDate: moment().format("YYYY-MM-DD"),
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
      },
      selectedRowKeys: [],
      isLoading: false,
      isShowModal: false,
      industryTypesArr: [],
      exhibitionsArr: [],
      employeesArr: [],
      columns: [
        {
          title: "ID",
          dataIndex: "id",
          key: "id",
          sorter: (a, b) => a.id - b.id,
          width: "10%",
        },
        { title: "Company Information", key: "initial_info" },
        { title: "Industry Type", key: "industry_type" },
        { title: "Exhibitions", key: "prospect_exhibitions" },
        { title: "Created By", key: "created_by" },
        {
          title: "Created At",
          dataIndex: "created_at",
          key: "created_at",
          sorter: (a, b) => a.created_at.localeCompare(b.created_at),
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["userInfo", "userPermissions"]),
    rowSelection() {
      return {
        selectedRowKeys: this.selectedRowKeys,
        onChange: (selectedRowKeys) => {
          this.selectedRowKeys = selectedRowKeys;
        },
      };
    },
  },
  watch: {
    exhibitions: {
      handler() {
        this.onSearch();
      },
      deep: true,
    },
    employees: {
      handler() {
        this.onSearch();
      },
      deep: true,
    },
  },
  mounted() {
    this.getCollections();
    this.getIndustryTypes();
    this.getExhibitions();
    this.getEmployees();

    if (this.$refs.dateRangeInput) {
      const start = moment().subtract(6, "days");
      const end = moment();
      new DateRangePicker(
        this.$refs.dateRangeInput,
        {
          startDate: moment(),
          endDate: moment(),
          ranges: {
            Today: [moment(), moment()],
            Yesterday: [
              moment().subtract(1, "days"),
              moment().subtract(1, "days"),
            ],
            "Last 7 Days": [moment().subtract(6, "days"), moment()],
            "Last 30 Days": [moment().subtract(29, "days"), moment()],
            "This Month": [moment().startOf("month"), moment().endOf("month")],
            "Last Month": [
              moment().subtract(1, "month").startOf("month"),
              moment().subtract(1, "month").endOf("month"),
            ],
            "All Time": [moment("1970-01-01"), moment()],
          },
        },
        this.booking_range
      );
    }
  },
  methods: {
    async getCollections(page = 1, pageSize = 10) {
      this.isLoading = true;
      try {
        const response = await http.get("prospects", {
          params: {
            page,
            per_page: pageSize,
            search: this.searchQuery,
            industry: this.selectedIndustryType,
            exhibitions: this.exhibitions.map((e) => Number(e.id)),
            employees: this.employees.map((e) => e.id),
            start_date: this.startDate,
            end_date: this.endDate,
          },
        });

        this.data = response.data.contents.data;
        this.pagination.total = response.data.contents.total;
        this.pagination.current = response.data.contents.current_page;
        this.pagination.pageSize = response.data.contents.per_page;
      } catch (error) {
        console.error("Error:", error);
      } finally {
        this.isLoading = false;
      }
    },
    handleTableChange(pagination) {
      this.getCollections(pagination.current, pagination.pageSize);
    },
    onSearch() {
      this.pagination.current = 1;
      this.getCollections(this.pagination.current, this.pagination.pageSize);
    },
    booking_range(start, end) {
      this.startDate = start ? start.format("YYYY-MM-DD") : null;
      this.endDate = end ? end.format("YYYY-MM-DD") : null;
      this.onSearch();
      return start.format("M/D/YYYY") + " - " + end.format("M/D/YYYY");
    },
    refresh() {
      this.isShowModal = false;
      this.getCollections();
    },
    async getIndustryTypes() {
      const res = await http.get("industries");
      this.industryTypesArr = res.data.contents.map((i) => ({
        id: i.id,
        name: i.type,
      }));
    },
    async getExhibitions() {
      const res = await http.get("/exhibitions");
      this.exhibitionsArr = res.data.contents.map((i) => ({
        id: i.id,
        name: i.name,
      }));
    },
    async getEmployees() {
      const res = await http.get("/employees");
      this.employeesArr = res.data.contents.map((e) => ({
        id: e.user_id,
        name: e.user.name,
      }));
    },
    async bulkDelete() {
      if (!this.selectedRowKeys.length)
        return this.$toast.error("No records selected.");
      if (
        !confirm(
          `Are you sure you want to delete ${this.selectedRowKeys.length} items?`
        )
      )
        return;

      try {
        await http.post("bulk-delete-prospects", {
          ids: [...this.selectedRowKeys],
        });
        this.$toast.success("Deleted successfully.");
        this.selectedRowKeys = [];
        this.getCollections();
      } catch (e) {
        this.$toast.error("Error deleting.");
      }
    },
    async downloadSampleFile() {
      try {
        const response = await http.get("/download-sample", {
          responseType: "blob",
        });

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "sample_import.xlsx";
        document.body.appendChild(a);
        a.click();

        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },
    async downloadEmailExcel() {
      try {
        const response = await http.post(
          "/download-all-email",
          {
            data: this.data,
          },
          {
            responseType: "blob",
            headers: {
              Accept: "application/octet-stream",
            },
          }
        );

        let filename = "email_list.csv";

        const blob = new Blob([response.data], {
          type: response.headers["content-type"],
        });

        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();

        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Error downloading the file:", error);
      }
    },
    goToUrl(path) {
      this.$router.push(path);
    },
    goToEditPage(id) {
      this.$router.push(`/prospect-update/${id}`);
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    openDeleteModal(row) {
      this.isShowModal = true;
      this.$nextTick(() => this.$emitter.emit("delete-item-modal", row));
    },
    importModal() {
      this.isShowModal = true;
      this.$nextTick(() => this.$emitter.emit("import-item-modal"));
    },
    canEdit(record) {
      return (
        this.userPermissions.includes("Prospect Edit") ||
        this.userInfo?.id == record.created_by
      );
    },
    canDelete(record) {
      return (
        this.userPermissions.includes("Prospect Delete") ||
        this.userInfo?.id == record.created_by
      );
    },
  },
};
</script>
<style scoped>
.custom-text-truncation {
  list-style-type: none; /* Remove default list styles */
  margin: 0;
  padding: 0;
  width: 100%; /* Ensure the list takes up the full width */
}

.custom-text-truncation li {
  overflow: hidden; /* Hide overflowing content */
  text-overflow: ellipsis; /* Use ellipsis for overflowing text */
  white-space: nowrap; /* Prevent the text from wrapping to the next line */
  display: block; /* Ensure list items are block-level */
  width: 100%; /* Ensure list items are responsive */
  max-width: 100%; /* Prevent content from spilling outside */
}

.custom-text-truncation li span {
  display: inline-block; /* Make sure the span behaves like inline-block */
  max-width: 200px; /* Set a max width to ensure truncation (adjust as needed) */
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.form-sort i {
  z-index: unset !important;
}
</style>
